<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import { AppTheme } from '~/types'
const store = useAppStore()
</script>

<template>
  <div
    class="fixed left-0 top-0 h-[100dvh] w-full overflow-hidden"
    :class="[store.theme === AppTheme.DARK ? 'bg-white' : 'bg-black']"
  />
</template>
